import { ReactElement } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingSpinnerProps {
  /**
   * If true, renders as full-page loading (takes full height)
   * If false, renders as inline loading (takes available space)
   * @default true
   */
  fullPage?: boolean;
  /**
   * Optional text to display below the spinner
   */
  text?: string;
  /**
   * Custom height for inline mode (defaults to "100%")
   */
  height?: string | number;
}

/**
 * Reusable loading spinner component
 * Can be used for full-page or inline loading states
 */
function LoadingSpinner({ 
  fullPage = true, 
  text,
  height = "100%"
}: LoadingSpinnerProps): ReactElement {
  if (fullPage) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", p: 3 }}>
        <CircularProgress />
        {text && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {text}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height, p: 3 }}>
      <CircularProgress />
      {text && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {text}
        </Typography>
      )}
    </Box>
  );
}

export default LoadingSpinner;
